let $ = window.$

$(() => {
    $('form input.is-invalid').change((e) => {
        $(e.target).removeClass('is-invalid')
    })
})